module.exports = __webpack_public_path__ + "img/imgPdtInfo2.211e0c0f.png";